import { uniq } from 'lodash'
import { SET_COLOR_PALETTE } from '@/store/mutation-types'
import ChartDataService from '@/services/ChartDataService'

const DEFAULT_COLOR_PALETTE = [
  '#005DA6',
  '#03A9F4',
  '#FF7900',
  '#F2C249',
  '#5F43C4',
  '#946FDD',
  '#00845B',
  '#18C482',
  '#A4C65F',
  '#AFE73E',
  '#B71C1C',
  '#F75B57',
  '#80AFD5',
  '#81D4FA',
  '#FFBC80',
  '#F8E1A4',
  '#AFA1E2',
  '#C9B7EE',
  '#80C2AD',
  '#8BE2C1',
  '#BFD09D',
  '#CBEC8A',
  '#DB8E8E',
  '#FBADAB',
  '#002644',
  '#014462',
  '#663000',
  '#604E1D',
  '#261B4E',
  '#3B2C58',
  '#003524',
  '#094E34',
  '#668032',
  '#74A611',
  '#490B0B',
  '#632422',
]

export default {
  namespaced: true,
  state: {
    colorPalette: [],
  },

  mutations: {
    [SET_COLOR_PALETTE](state, colorPalette) {
      state.colorPalette = colorPalette
    },
  },
  actions: {
    async getColorPalette({ state, commit }) {
      if (!state.colorPalette.length) {
        const colorPalette = (await ChartDataService.getColorPalette()).data
        const configuredPalette = colorPalette && Array.isArray(colorPalette) ? colorPalette : []
        commit(SET_COLOR_PALETTE, uniq(configuredPalette.concat(DEFAULT_COLOR_PALETTE)))
      }
    },
  },
  getters: {
    colorPalette(state) {
      return state.colorPalette
    },
    primaryColor(state) {
      return state.colorPalette[0]
    },
    secondaryColor(state) {
      return state.colorPalette[1]
    },
  },
}
